import React from 'react';
import PropTypes from 'prop-types';
import TidalLogo from '../../../../assets/images/promos/tidal/tidal-logo-white.svg';

const PromoTidal = ({ payButton }) => (
  <div className="c-promo-tidal">
    <div className="c-promo-tidal-header">
      <img className="c-promo-tidal-header_logo" src={TidalLogo} alt="TIDAL" />
      <p>
        Reserve with a card now and you will receive&nbsp;
        <b>2 free months of music streaming with TIDAL - a $20 value</b>
      </p>
    </div>
    <div className="c-promo-tidal-details">
      <div className="c-promo-tidal-details_title">
        Other benefits to paying now
      </div>
      <ul>
        <li>save time by not having to wait to pay </li>
        <li>stay safe and sanitary by touching fewer surfaces</li>
      </ul>
      {payButton()}
      <p className="c-promo-tidal-details_terms">
        Not available for current or past TIDAL subscribers. TIDAL Terms & Conditions apply
      </p>
    </div>
  </div>
);

PromoTidal.propTypes = {
  payButton: PropTypes.func.isRequired,
};

export default PromoTidal;



// WEBPACK FOOTER //
// ./src/app/reservation/components/PromoTidal.jsx